<template>
  <v-row justify="center">
    <v-dialog
      v-model="openDialog"
      persistent
      max-width="700"
      scrollable
      transition="dialog-bottom-transition"
    >
      <v-card class="app-download-card">
        <v-row no-gutters class="app-download-row" align="center">
          <v-col
            cols="12"
            align="center"
            class="app-download-rcol justify-center app-download-mobile-img-content"
          >
            <v-img
              :src="happyly_image_mobile"
              class="app-download-mobile-img"
            ></v-img>
          </v-col>
          <v-col
            cols="12"
            md="6"
            sm="8"
            xs="12"
            align="center"
            class="app-download-lcol"
          >
            <p class="font-weight-bold app-download-header">
              Happyly is better in app
            </p>
            <p class="font-weight-bold app-download-details">
              Get the Happyly app to discover more
              <span class="secondary--text">activities like this one</span>,
              plus
              <span class="secondary--text">get curated adveture plans</span>,
              build <span class="secondary--text">lists</span> of activities to
              try and more!
            </p>
            <v-row no-gutters class="phone-number-row">
              <v-col cols="12" align="left">
                <p class="app-download-phone ma-3 mt-0 text-uppercase">
                  Enter your phone number to receive a download link
                </p>
              </v-col>
              <v-col cols="12">
                <vue-tel-input-vuetify
                  id="app-donwload-phone-input"
                  v-model="phone"
                  outlined
                  dense
                  persistent-hint
                  disabled-fetching-country
                  :label="label"
                  :append-icon="append_icon"
                  :mode="mode"
                  required
                  :placeholder="placeholder"
                  :error-messages="error_phone_message"
                  :error="invalid_phone"
                  :input-options="input_options"
                  :default-country="default_country"
                  :only-countries="countries_list"
                  @input="validatePhoneNumber"
                  @keydown="keyHandler"
                ></vue-tel-input-vuetify>
                <v-col cols="12" align="left" class="pa-0 mt-3">
                  <v-btn
                    id="sms-button"
                    depressed
                    x-medium
                    tile
                    color="secondary"
                    class="input-button"
                    :disabled="invalid_phone"
                    @click="sendSMS"
                  >
                    <v-col v-show="!loading" class="ma-0 pa-0">Send Link</v-col>
                    <v-progress-circular
                      v-show="loading"
                      :size="20"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-btn>
                </v-col>
              </v-col>
            </v-row>
            <div class="download-store-buttons mt-2 d-flex flex-wrap">
              <AppStoreButton max-width="120" />
              <div class="buttons-store-divider"></div>
              <PlayStoreButton max-width="120" />
            </div>
          </v-col>
          <v-col
            cols="12"
            md="6"
            sm="4"
            xs="0"
            align="center"
            class="app-download-rcol justify-center"
          >
            <v-img
              :src="happyly_image"
              class="app-download-desktop-img"
            ></v-img>
          </v-col>
        </v-row>
        <v-snackbar
          v-model="showMessage"
          color="blue-grey"
          right
          rounded="pill"
          bottom
        >
          {{ message }}
        </v-snackbar>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import AppStoreButton from '@/components/AppStoreButton'
import PlayStoreButton from '@/components/PlayStoreButton'
import smsMixin from '@/mixins/smsMixin'
import phoneNumberMixin from '@/mixins/phoneNumberMixin'

export default {
  name: 'AppDownloadDialog',
  components: { AppStoreButton, PlayStoreButton },
  mixins: [smsMixin, phoneNumberMixin],
  props: {
    openAppDownloadDialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    happyly_image: require('@/assets/images/screenshots/bg_download_app.png'),
    happyly_image_mobile: require('@/assets/images/screenshots/bg_download_app_mobile.png'),
    phone: '',
    showMessage: false,
    message: null,
    loading: false,
  }),
  computed: {
    openDialog: {
      get() {
        return this.openAppDownloadDialog
      },
      set(val) {
        this.$emit('updateDialog', false)
      },
    },
  },
  mounted() {
    this.invalid_phone = true
  },
  methods: {
    clearPhoneData() {
      this.phone = ''
      this.clean_phone_number = null
      this.clean_country_code = null
      this.invalid_phone = true
    },
    sendSMS() {
      if (this.clean_phone_number !== '' && this.clean_country_code !== '') {
        this.loading = true
        this.sendDownloadLink(
          `+${this.clean_country_code}`,
          this.clean_phone_number
        ).then(
          () => {
            this.clearPhoneData()

            this.showMessage = true
            this.message = 'The SMS has been sent!'
            this.loading = false
          },
          (error) => {
            this.clearPhoneData()

            this.showMessage = true
            this.message = error.message
            this.loading = false
          }
        )
      }
    },
  },
}
</script>

<style scoped>
.app-download-card {
  border-radius: 5px;
  border: 8px solid #276b6c !important;
  background-color: #276b6c;
}
.app-download-row {
  border-radius: 5px;
  background-color: white;
  overflow: auto;
}
.app-download-header {
  font-size: 2rem;
  text-align: left;
}
.app-download-details {
  font-size: 1rem;
  text-align: left;
}
.app-download-phone {
  font-size: 0.6rem;
  line-height: 1rem;
  margin-left: 0px !important;
}
.app-download-lcol {
  padding: 25px;
}
.app-download-rcol {
  padding: 25px 25px 25px 0px;
}
.input-button {
  border-radius: 12px !important;
  text-transform: none !important;
  height: auto !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  font-weight: 200 !important;
}
#app-donwload-phone-input {
  max-height: 15px;
  margin-top: 26px;
}
#sms-button {
  background-color: #276b6c !important;
  border-color: #276b6c !important;
  color: white !important;
  min-width: 100px;
}
.app-download-mobile-img-content {
  display: none;
}
.app-download-mobile-img {
  max-width: 320px;
}
.app-download-desktop-img {
  max-width: 434px;
}
.download-store-buttons {
  align-items: flex-start;
  justify-content: flex-start;
}

.buttons-store-divider {
  width: 12px;
  display: flex;
}
@media (max-width: 599px) {
  .app-download-rcol,
  .phone-number-row,
  .buttons-store-divider {
    display: none;
  }
  .download-store-buttons {
    align-items: center !important;
    justify-content: space-around !important;
  }
  .app-download-mobile-img-content {
    display: block;
  }
  .app-download-lcol {
    padding-top: 0px;
  }
  .app-download-rcol {
    padding: 0px 25px;
  }
  .app-download-details {
    padding-bottom: 4px;
  }
}
@media (max-width: 400px) {
  .app-download-phone {
    font-size: 0.55rem;
  }
}
@media (max-width: 390px) {
  .download-store-buttons {
    align-items: center;
    justify-content: center;
  }
}
</style>
